import BN from 'bn.js';

export const FET_ERC20 : {
    [multiplier: string]: BN
} = {
    multiplier: new BN('1000000000000000000')  // according to decimals, to convert FET into the smallest unit of FET
};

export interface ContractConfig {
    [key: string]: string;
}

export const CONTRACT_CONFIG: ContractConfig = {
    contractAddress: process.env.REACT_APP_CONTRACT_ADDRESS ?? "",
    tokenAddress: process.env.REACT_APP_TOKEN_ADDRESS ?? "",
}